import { render, staticRenderFns } from "./PrivacyForm.vue?vue&type=template&id=1e41c078&scoped=true"
import script from "./PrivacyForm.vue?vue&type=script&lang=js"
export * from "./PrivacyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e41c078",
  null
  
)

export default component.exports